
import {values} from '@/ft-vue-core'

const {daysLower} = values

export default {
  data: function () {
    return {
      guestTypes: [],
      mealPeriods: [],
      events: [],
      locations: [],
      occasions: [],
      confirmationStatuses: [],
      itemsHaveIssue: false
    }
  },
  methods: {
    guestTypesCommand () {
      return [
        {
          command: 'guestType',
          load: this.guestTypes,
          loading: this.isLoading,
          params: {filter: [{field: 'activityId', operator: 'EQUAL', values: [9999]}]}
        }
      ]
    },
    eventsResourceCommand () {
      /*
      const filters = []
      if (this.minFilterDateTime) {
        filters.push({ field: 'startDateTime', operator: 'GREATER_OR_EQUAL', values: [this.minFilterDateTime] })
      }
      if (this.maxFilterDateTime) {
        filters.push({ field: 'startDateTime', operator: 'LESS_OR_EQUAL', values: [this.maxFilterDateTime] })
      }
      */
      return {
        command: 'diningEvent',
        load: this.events,
        loading: this.isLoading,
        params: {
          include_fields: ['costs'],
          order_by: ['name:ASC', 'date:ASC'] /*,
          filter: filters */
        }
      }
    },
    listResourceCommands () {
      if (this.loadedListResources) return []
      return [
        ...this.guestTypesCommand(),
        this.eventsResourceCommand(),
        {command: 'diningConfirmationStatus', load: this.confirmationStatuses, loading: this.isLoading},
        {command: 'diningLocation', load: this.locations, loading: this.isLoading},
        {command: 'diningOccasion', load: this.occasions, loading: this.isLoading},
        {command: 'diningMealPeriod', load: this.mealPeriods, loading: this.isLoading, params: {include_disabled: false, include_fields: ['overlappingIds', 'locationName']}}
      ]
    },
    beforeItemsLoad (data) {
      // If any items have issues, set value showing our list has issues
      this.itemsHaveIssue = !!data.find(i => i.issues)
    },
    listSearchFilter () {
      const filters = []
      if (!this.searchFilter.guestTypeId && this.searchFilter.memberId) {
        filters.push({
          field: 'id',
          operator: 'IN',
          subQueryTarget: 'diningReservationDetail.reservationId',
          subQueryFilter: [
            {field: 'memberId', operator: 'EQUAL', values: [this.searchFilter.memberId]},
            ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
          ]
        })
      }
      if (this.searchFilter.eventCostName) {
        const values = this.selectedEventsCostsFilter.reduce((acc, c) => {
          if (c.name === this.searchFilter.eventCostName) {
            acc.push(c.id)
          }
          return acc
        }, [])
        if (values.length) {
          const subQueryFilter = [
            {field: 'eventCostId', operator: 'IN', values: values},
            ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
          ]
          filters.push({
            field: 'id',
            operator: 'IN',
            subQueryTarget: 'diningReservationDetail.reservationId',
            subQueryFilter: subQueryFilter
          })
        }
      }
      if (this.searchFilter.guestTypeId) {
        const subQueryFilter = [
          {field: 'guestTypeId', operator: 'EQUAL', values: [this.searchFilter.guestTypeId]},
          ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
        ]
        if (!(this.guestTypeMap[this.searchFilter.guestTypeId] || {}).isTbd && this.searchFilter.guestSearch) {
          subQueryFilter.push({
            field: 'name',
            operator: 'LIKE',
            values: [this.searchFilter.guestSearch + '%']
          })
        }
        filters.push({
          field: 'id',
          operator: 'IN',
          subQueryTarget: 'diningReservationDetail.reservationId',
          subQueryFilter: subQueryFilter
        })
      }
      if (this.searchFilter.reservationNumber) {
        filters.push({field: 'id', operator: 'EQUAL', values: [this.searchFilter.reservationNumber]})
      }
      // if (this.searchFilter.mealPeriodId && this.$ftCS.DINING_USES_RESERVATIONS) {
      //   filters.push({field: 'mealPeriodId', operator: 'EQUAL', values: [this.searchFilter.mealPeriodId]})
      // }
      if (!this.selectedEventsCostsFilter.length && this.clubUsesMealPeriods &&
        this.searchFilter.mealPeriodIds && this.searchFilter.mealPeriodIds.length && this.$ftCS.DINING_USES_RESERVATIONS) {
        filters.push({field: 'mealPeriodId', operator: 'IN', values: this.searchFilter.mealPeriodIds})
      }
      if (this.searchFilter.locationId) {
        filters.push({field: 'locationId', operator: 'EQUAL', values: [this.searchFilter.locationId]})
      }
      if (this.searchFilter.origByField) {
        filters.push({field: this.searchFilter.origByField, operator: 'IS_NOT_NULL'})
      }
      if (this.searchFilter.mealPeriodId) {
        filters.push({field: 'mealPeriodId', operator: 'EQUAL', values: [this.searchFilter.mealPeriodId]})
      }
      if (!this.$ftCS.DINING_USES_RESERVATIONS && this.$ftCS.DINING_USES_EVENTS) {
        // Only event reservations
        filters.push({
          field: 'eventId',
          operator: 'IS_NOT_NULL'
        })
      }
      if (this.searchFilter.eventName && this.$ftCS.DINING_USES_EVENTS) {
        filters.push({
          field: 'eventId',
          operator: 'IN',
          subQueryTarget: 'diningEvent.id',
          subQueryFilter: [
            {field: 'name', operator: 'EQUAL', values: [this.searchFilter.eventName]}
          ]
        })
      }
      if (this.searchFilter.date) {
        filters.push({
          field: 'dateTime',
          operator: 'BETWEEN',
          values: [
            this.searchFilter.date + ' 00:00:00',
            this.searchFilter.date + ' 23:59:59'
          ]
        })
      }
      if (this.searchFilter.confirmationStatusId) {
        filters.push({field: 'confirmationStatusId', operator: 'EQUAL', values: [this.searchFilter.confirmationStatusId]})
      }
      if (!this.searchFilter.cancelled) {
        filters.push({field: 'cancelled', operator: 'IS_NULL'})
      }
      const selectedDays = daysLower.map((d, i) => {
        return {dayName: d, day: i + 1}
      }).filter(d => this.searchFilter.days[d.dayName]).map(d => d.day)
      if (selectedDays.length) {
        filters.push({field: 'dayOfWeek', operator: 'IN', values: selectedDays})
      }
      if (this.showWaitlist !== null) {
        filters.push({field: 'waitlist', operator: 'EQUAL', values: [!!this.showWaitlist]})
      }
      return filters
    },
    listCommandFilter (command) {
      command.afterLoad = () => {
        this.loadedListResources = true
      }
      this.addCommandParamArray(command, 'include_fields', [
        'eventName',
        'locationName',
        'reservationStateName',
        'confirmationStatus',
        'originator',
        'issues',
        'tableAssignments',
        'noShows',
        'details',
        'diningReservationDetail.member',
        'created',
        'hasBirthday'
      ])
      this.addCommandParamArray(command, 'exclude_fields', [
        // We only want the member photo and food/drink/allergy fields
        'memberSearch.nameFirst',
        'memberSearch.nameLast',
        'memberSearch.nameFull',
        'memberSearch.nameMi',
        'memberSearch.nameSuf',
        'memberSearch.namePre',
        'memberSearch.webid'
      ])
      this.addCommandParam(command, 'row_count', true)
      this.addCommandParamArray(command, 'filter', this.listSearchFilter())
      const order = (this.listingSortOrderMap[this.searchFilter.listingSortOrderId] || {}).order
      if (order) {
        this.addCommandParam(command, 'order_by', order)
      }
      return command
    }
  }
}
